module.exports = __webpack_public_path__ + "img/door-closed.4ea99131.svg";